export const guessIsWebView = () => {
  // this implements requirements coming from Android app webview integration
  const params = new URLSearchParams(window.location.search);
  const isWebView = params.has("ctheme");
  return isWebView;
};
